function isMobileDevice() {
    return window.innerWidth <= 768;
  }
  
  function appendRegistryButton() {
    if (isMobileDevice()) {
      const registryButton = document.querySelector('.gift-reggie-buttons');
      const targetElement = document.querySelector('.product-single__meta');
  
      if (targetElement && registryButton) {
        targetElement.appendChild(registryButton);
        registryButton.style.opacity = '1';
      }
    }
  }
  
  function waitForElement(selector, callback) {
    const element = document.querySelector(selector);
  
    if (element) {
      callback();
      clearInterval(intervalID);
    } else {
      setTimeout(() => waitForElement(selector, callback), 100);
    }
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    intervalID = setInterval(() => {
      waitForElement('.product-single__meta', appendRegistryButton);
    }, 100);
  });
  